import PropTypes from 'prop-types'
import React from 'react'

import DateComponent from 'components/Date'
import Modal from 'components/Modal'

export const CutoffModal = (props) => <Modal
  isOpen={props.isOpen}
  contentLabel='Past cutoff to order.'
  onRequestClose={props.closeAction}
  title={`Past Order Cutoff`}
  buttons={[
    { text: 'Hide', options: ['red'], callback: props.closeAction }
  ]}
>
  <p>It's past the cutoff to order for this day.
    <br />To make changes or order, please call or text us at <mark>(415) 275-2292</mark>.
  </p>

  <br />
  <DateComponent {...props}
    date={props.date}
    textFormat='Switch Date'
    onClick={props.closeAction}
  />
</Modal>

CutoffModal.propTypes = {
  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
  successCallback: PropTypes.func,
  errorCallback: PropTypes.func,

  // for the url generation
  date: PropTypes.any,
  baseUrl: PropTypes.string,

  location: PropTypes.object,
  params: PropTypes.object
}

CutoffModal.defaultProps = {
  isOpen: false
}

export default CutoffModal



// WEBPACK FOOTER //
// ./src/containers/Modals/Cutoff/Cutoff.js